var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-grid',{attrs:{"url":_vm.url,"columns":_vm.columns,"title":_vm.title,"onLoaded":_vm.onLoaded,"beforeSetupGrid":_vm.beforeSetupGrid}})}
var staticRenderFns = []

export { render, staticRenderFns }